const PENDING_STATE = 2;
const PAID_STATE = 3;

interface AdministrativeFormStateTagProps {
    stateType: number | null | undefined;
}

/** Estado de un comprobante (interno u orden de pago) de la rendición o la liquidación (DS §3.4): tag con color + texto. */
export default function AdministrativeFormStateTag({ stateType }: AdministrativeFormStateTagProps) {
    if (stateType === PENDING_STATE) return <span className="md-tag md-tag-warn">Pendiente</span>;
    if (stateType === PAID_STATE) return <span className="md-tag md-tag-ok">Pagado</span>;
    return <>—</>;
}
